import styled from 'styled-components'

export const ReactJsonContainer = styled.div`
  .object-key-val > span > span {
    display: inherit !important;
  }
`
